import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _get from 'lodash/get';
import _throttle from 'lodash/throttle';
import { updateResourceProgress } from 'containers/Resources/actions';
import {
  makeSelectResourcesProgress,
  makeSelectResourcesProgressProcessing,
} from 'containers/Resources/selectors';

const useResourceProgress = ({ resourceId, resourceType }) => {
  const dispatch = useDispatch();
  const resourcesProgress = useSelector(makeSelectResourcesProgress());
  const resourcesProgressProcessing = useSelector(
    makeSelectResourcesProgressProcessing(),
  );
  const initialTime = _get(resourcesProgress, [resourceId, 'progress']) || 0;

  const handleProgressUpdate = useCallback(
    progress => {
      dispatch(
        updateResourceProgress({
          resourceId,
          progress,
          type: resourceType,
        }),
      );
    },
    [resourceId, dispatch, resourceType],
  );

  const throttledSaveProgress = useCallback(
    _throttle(handleProgressUpdate, 10_000),
    [handleProgressUpdate],
  );

  return {
    initialTime,
    processing: resourcesProgressProcessing,
    onProgressUpdate: throttledSaveProgress,
  };
};

export default useResourceProgress;
